import * as i from 'icepick'
import { IContactClient } from 'features/Contacts/types'

export interface IContactsState {
  contactsById: {
    [contactId: string]: {
      loading: boolean
      error: any
      data: IContactClient
    }
  }
  list: {
    [cacheKey: string]: {
      loading: boolean
      error?: any
      data?: {
        results: string[]
        totalPages: number
        totalResults: number
        page: number
        limit: number
      }
    }
  }
}

const initialState: IContactsState = {
  contactsById: {},
  list: {},
}

export const contactsReducer = (state: IContactsState = initialState, action): IContactsState => {
  switch (action.type) {
    case 'CONTACTS/SUBSCRIBE_TO_FLOW_FULFILLED':
      return i
        .chain(state)
        .assocIn(['contactsById', action.meta.contactId, 'data'], action.payload.data.contact)
        .value()

    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/features/Contacts/Contacts.reducer.ts